// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"7d5cbc8b","488":"a298c53a","652":"19a426e4","715":"2ba96251","739":"96e3dace","747":"fd580e22","771":"146fa92e","879":"0cd565f4"}[chunkId] + ".chunk.js";
};